<template>
  <result-card
    icon="mdi-clock-outline"
    icon-color="#FF9100"
    title="Платеж обрабатывается"
    text="Ждём подтверждения от банка. Баланс пополнится сам — страницу можно закрыть."
    action-label="Вернуться к заказам"
    @action="$emit('action')"
  />
</template>

<script>
  import ResultCard from './ResultCard'

  export default {
    name: 'PaymentPending',
    components: { ResultCard },
  }
</script>
